import React from "react";
import PropTypes from "prop-types";

function IconoCarpeta({ uid, anio, texto, numero }) {
  const displayText = texto !== undefined && texto !== null ? texto : anio;
  const hasNumero = numero !== undefined && numero !== null && numero !== "";
  const gradientId = `grad-${uid || displayText || numero || "carpeta"}`;

  return (
    <svg
      className="IconoCarpeta"
      viewBox="0 0 200 170"
      role="img"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="var(--ite-color-primary, #B5179E)" />
          <stop offset="100%" stopColor="var(--ite-color-primary-dark, #7A0B6B)" />
        </linearGradient>
      </defs>

      {/* Tapa trasera de la carpeta */}
      <path
        className="IconoCarpeta__fondo"
        fill={`url(#${gradientId})`}
        d="M10 30a10 10 0 0 1 10-10h50l14 14h96a10 10 0 0 1 10 10v96a10 10 0 0 1-10 10H20a10 10 0 0 1-10-10z"
      />

      {/* Hoja blanca interior móvil */}
      <g className="IconoCarpeta__hoja">
        <rect
          x="24"
          y="48"
          width="152"
          height="74"
          rx="6"
          fill="#ffffff"
        />

        {hasNumero ? (
          /* 3 líneas decorativas que simulan texto de documento */
          <g className="IconoCarpeta__lineas" aria-hidden="true">
            <rect x="42" y="66" width="68" height="5" rx="2.5" fill="#C5C5D2" />
            <rect x="42" y="78" width="116" height="5" rx="2.5" fill="#D8D8E4" />
            <rect x="42" y="90" width="92" height="5" rx="2.5" fill="#D8D8E4" />
          </g>
        ) : (
          /* Texto o año en el centro de la hoja */
          <text
            className="IconoCarpeta__anio"
            x="100"
            y="94"
            textAnchor="middle"
            dominantBaseline="middle"
          >
            {displayText}
          </text>
        )}
      </g>

      {/* Franja frontal de la carpeta */}
      <rect
        className="IconoCarpeta__frente"
        x="10"
        y="108"
        width="180"
        height="52"
        rx="10"
        fill={`url(#${gradientId})`}
      />

      {/* Número en blanco centrado en la franja frontal */}
      {hasNumero && (
        <text
          className="IconoCarpeta__numero"
          x="100"
          y="136"
          textAnchor="middle"
          dominantBaseline="middle"
        >
          {numero}
        </text>
      )}
    </svg>
  );
}

IconoCarpeta.propTypes = {
  uid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  anio: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  texto: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  numero: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default IconoCarpeta;
